import * as React from 'react';
import { useContext } from "react";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';

import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import Paper from '@mui/material/Paper';

import { useEffect, useState } from 'react';
import { PreciosContext } from "../hooks/PricesContext";
import * as functions from "../functions/Screener"

import Image from "./fondo4.jpg";
import { Typography } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';



function descendingComparator(a, b, orderBy) {
  if (orderBy === 'Variacion') {
    // Comparar los valores de variación directamente
    const aValue = a[orderBy];
    const bValue = b[orderBy];

    // Si los valores son diferentes, retornar el resultado de la comparación
    if (aValue !== bValue) {
      return bValue - aValue; // Ordenar de mayor a menor
    }

    // Si los valores son iguales, retornar 0
    return 0;
  }

  // Convertir los valores a números antes de comparar
  const aValue = typeof a[orderBy] === 'string' ? parseFloat(a[orderBy]) : a[orderBy];
  const bValue = typeof b[orderBy] === 'string' ? parseFloat(b[orderBy]) : b[orderBy];

  // Manejar la comparación normal para todas las columnas excepto "Variacion"
  if (orderBy !== 'Variacion') {
    if (bValue < 0 && aValue >= 0) {
      return 1;
    }
    if (bValue >= 0 && aValue < 0) {
      return -1;
    }
  }

  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Empresa',
  },
  {
    id: 'Precio',
    numeric: true,
    disablePadding: false,
    label: 'Precio',
  },
  {
    id: 'Variacion',
    numeric: true,
    disablePadding: false,
    label: 'Variacion',
  },
  {
    id: 'PER',
    numeric: true,
    disablePadding: false,
    label: 'PER',
  },
  {
    id: 'EVtoFCF',
    numeric: true,
    disablePadding: false,
    label: 'EV/FCF',
  },
  {
    id: 'PtoSales',
    numeric: true,
    disablePadding: false,
    label: 'P/Sales',
  },
  {
    id: 'MgNet',
    numeric: true,
    disablePadding: false,
    label: 'MgNet',
  },
];

export function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, selectedRatios } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell key="name" align="left" sx={{ backgroundColor: "lightgrey", fontWeight: "bold" }}>
          Empresa
        </TableCell>
        {headCells.map((headCell) => (
          selectedRatios[headCell.id] && (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? 'center' : 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ backgroundColor: "lightgrey", fontWeight: "bold" }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={() => onRequestSort(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}


export default function EnhancedTable() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('PER');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRatios, setSelectedRatios] = useState({
    PER: true,
    EVtoFCF: true,
    PtoSales: true,
    Precio: true,
    Variacion: true,
    MgNet: true,
  });

  const myStyle = {
    backgroundImage: `url(${Image})`,
    height: "100%",
    minHeight: "90vh",
    marginTop: "0px",
    backgroundSize: "cover",
    width: "100%",
    backgroundRepeat: "no-repeat",
    paddingBottom: "30px",
    paddingTop: "20px",
  };

  const { stocks } = useContext(PreciosContext);

  useEffect(() => {
    setIsLoading(true);
    const formattedData = stocks.map((stock) => {
      const PER = ((stock.price * stock.Acciones) / stock.NetIncome).toFixed(2);
      let EVtoFCF;
      if (stock.category === "Financiero") {
        // Calcular EV/FCF igual que P/FCF para categoría Financiero
        EVtoFCF = PER;
      } else {
        EVtoFCF = (((stock.price * stock.Acciones) + stock.Debt - stock.CashandEquiv) / (stock.NetIncome + stock.DandA - stock.CAPEX)).toFixed(2);
      }
      const PtoSales = ((stock.price * stock.Acciones) / stock.Revenue).toFixed(2);
      const Precio = parseFloat(stock.actual_price || stock.price);
      const Variacion = stock.previous_close
        ? parseFloat(((stock.actual_price - stock.previous_close) / stock.previous_close))
        : 0;
      const MgNet = stock.NetIncome / stock.Revenue;
      console.log(stock.price)

      return {
        name: stock.name,
        PER: PER,
        EVtoFCF: EVtoFCF,
        PtoSales: PtoSales,
        Precio: Precio,
        Variacion: Variacion,
        MgNet: MgNet,
      };
    });

    if (formattedData.length > 0) {
      setIsLoading(false);
    }
    setRows(formattedData);
  }, [stocks]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRatioSelectionChange = (ratio) => {
    setSelectedRatios((prevSelectedRatios) => ({
      ...prevSelectedRatios,
      [ratio]: !prevSelectedRatios[ratio],
    }));
  };

  const visibleRows = React.useMemo(
    () => stableSort(rows, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    ),
    [rows, order, orderBy, page, rowsPerPage],
  );

  return (
    <Box style={myStyle} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Paper sx={{ width: '96%', display: 'flex', flexDirection: 'column' }}>
        {/* Esta es la box del selector de ratios, por ahora desactivado */}
        <Box sx={{ display: { xs: 'none', md: "none" }, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
          <Box>
            {Object.keys(selectedRatios).map((ratio) => (
              <label key={ratio}>
                <input
                  type="checkbox"
                  checked={selectedRatios[ratio]}
                  onChange={() => handleRatioSelectionChange(ratio)}
                />
                {ratio}
              </label>
            ))}
          </Box>
        </Box>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={rows.length} selectedRatios={selectedRatios} />
            <TableBody>
              {isLoading ? (
                <TableRow><TableCell colSpan={10}>Cargando...</TableCell></TableRow>
              ) : (
                visibleRows.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow hover role="checkbox" tabIndex={1} key={row.name} sx={{ cursor: 'pointer' }}>
                      <TableCell component="th" id={labelId} scope="row" sx={{ fontWeight: 'bold', fontSize: '16px' }}>{row.name}</TableCell>
                      {headCells.map((headCell) => (
                        selectedRatios[headCell.id] && (
                          <TableCell align="center" key={headCell.id}>
                            {headCell.id === 'name' ? row.name : (
                              headCell.id === 'Precio' ?
                                `$ ${row[headCell.id].toFixed(2)}` :
                                (headCell.id === 'Variacion' ?
                                  <span style={{ color: row.Variacion >= 0 ? 'green' : 'red' }}>
                                    {(row[headCell.id] * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}%
                                  </span> : (headCell.id === 'MgNet') ?
                                    `${(row[headCell.id] * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}%` : row[headCell.id]
                                )
                            )}
                          </TableCell>
                        )
                      ))}
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}